<app-header></app-header>
<div id="print-section">
  <div class="success_main py-4">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-11">
          <p *ngIf="status == 'Success'">
            <i class="fa fa-check"></i> Invoice Payment
            <span class="smalltxt">Your invoice payment has been processed successfully.</span>
          </p>
          <p *ngIf="status == 'Failure'">
            <i class="fa fa-exclamation paymentFailure"></i> Invoice Payment
            <span class="smalltxt">Sorry, there was an issue processing your invoice payment.</span>
          </p>
        </div>
        <div class="col-1 text-end">
          <a (click)="print()">
            <i class="fa fa-print print_icon cursor-pointer"></i>
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="container below_header">
    <div class="row">
      <div class="col-12">
        <div>
          <span class="order_id transIDWordBreak">Transaction ID : {{transactionStatus.transactionId}}</span>
        </div>
        <div class="detail_list mt-3">
          <p>
            <b>Order ID(s) :</b> {{transactionStatus.orderId}}
          </p>
          <p>
            <b>Invoice ID(s) :</b> {{transactionStatus.invoiceIds}}
          </p>
        </div>
        <div class="payment_detail_main mt-4">
          <i class="fa fa-credit-card payment_detail_icon"></i>
          <span class="payment_detailtxt">Payment Details</span>
          <div class="blw_paymentdetail mt-2">
            <p class="full_paymenttxt" *ngIf="transactionStatus.paymentMode === 'ACH'">Total Net Cash Discount Price</p>
            <p class="full_paymenttxt" *ngIf="transactionStatus.paymentMode === 'CC'">Total Net Regular Price</p>
            <p class="full_payment">{{transactionStatus.amountPaid | currency:'USD'}}</p>
          </div>
        </div>
        <div *ngIf="status == 'Success'" id="goToHome" class="mt-4">
          <button type="button" (click)="home($event)" class="btn btn-success gohome">
            <i class="fa fa-home home_icon"></i> Go Home
          </button>
        </div>
        <div *ngIf="status == 'Failure'" id="goToHome" class="mt-4">
          <button type="button" (click)="home($event)" class="btn btn-danger gohomeFail">
            <i class="fa fa-home home_icon"></i> Go Home
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
